@if (cmsReady()) {
    <pdp-template [marketProductId]="product.marketProductId" (statusChanged)="onStatusChanged($event)">
        <div slot="buyBoxTitle">
            @if(productNumber) {
                <div class="product-number">
                    <span translate="cart.product.number"></span>{{productNumber}}
                </div>
            }
            <h1 class="heading-2 product-name" automation-tag="productName"
                [innerHTML]="productGroup.productDescription.name"></h1>
        </div>
        <product-buy-box slot="buyBox" [productGroup]="productGroup" [product]="product"></product-buy-box>
    </pdp-template>
}
